module.exports = __webpack_public_path__ + "img/91448dd.jpg";